module.exports = __webpack_public_path__ + "static/media/group_25@3x.aa916632.jpg";